import type { LawToneName } from './LawToneName';

/** Тип норми статті (прототип NC): визначення — нейтральне, право — зелене, обов'язок — синій, заборона — червона, процедура — бурштинова, санкція — рожева. */
const NORM: Readonly<Record<string, LawToneName>> = { Definition: 'neutral', Right: 'good', Obligation: 'blue', Prohibition: 'bad', Procedure: 'mixed', Sanction: 'pink' };
/** Напрям впливу (прототип DIR; інше — змішаний). */
const DIRECTION: Readonly<Record<string, LawToneName>> = { Positive: 'good', Negative: 'bad', Mixed: 'mixed' };
/** Позиція зацікавленої сторони (прототип ST; інше — нейтральна). */
const STANCE: Readonly<Record<string, LawToneName>> = { Supports: 'good', 'Supports with changes': 'mixed', Neutral: 'neutral', Opposes: 'bad' };
/** Статус правки, коментаря чи версії (прототип EC; інше — як чернетка). */
const CARD: Readonly<Record<string, LawToneName>> = {
  Proposed: 'mixed', Accepted: 'good', Rejected: 'bad', Open: 'mixed', Resolved: 'muted', Draft: 'mixed', Approved: 'good', Registered: 'blue',
};
/** Рівень аналітичного запису (прототип AC; інше — низький). */
const LEVEL: Readonly<Record<string, LawToneName>> = { High: 'bad', Critical: 'critical', Medium: 'mixed', Low: 'muted' };
/** Крапка серйозності колізії (прототип SEV; інше — сіра). */
const SEVERITY: Readonly<Record<string, string>> = { Critical: '#b42318', High: '#c2410c', Medium: '#b7791f', Low: '#64748b' };

const key = (value: unknown) => (value == null ? '' : String(value));

/** Тон типу норми статті. Чиста функція. */
export function normTone(norm: unknown): LawToneName { return NORM[key(norm)] ?? 'neutral'; }
/** Тон напряму впливу. */
export function directionTone(direction: unknown): LawToneName { return DIRECTION[key(direction)] ?? 'mixed'; }
/** Тон позиції зацікавленої сторони. */
export function stanceTone(stance: unknown): LawToneName { return STANCE[key(stance)] ?? 'neutral'; }
/** Тон статусу правки, коментаря чи версії. */
export function cardTone(status: unknown): LawToneName { return CARD[key(status)] ?? 'mixed'; }
/** Тон рівня аналітичного запису (вплив, цінність, впевненість, серйозність). */
export function levelTone(level: unknown): LawToneName { return LEVEL[key(level)] ?? 'muted'; }
/** Колір крапки серйозності колізії. */
export function severityDot(severity: unknown): string { return SEVERITY[key(severity)] ?? '#64748b'; }
